import { render, staticRenderFns } from "./MyCreations.vue?vue&type=template&id=c4714b94&scoped=true"
import script from "./MyCreations.vue?vue&type=script&lang=js"
export * from "./MyCreations.vue?vue&type=script&lang=js"
import style0 from "./MyCreations.vue?vue&type=style&index=0&id=c4714b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4714b94",
  null
  
)

export default component.exports